import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {
  type GlobalSearchParameters,
  type GlobalSearchResponse,
  type GlobalSearchResultItem,
  type PaginationHeader
} from '../types'

export const UpmGlobalSearchQueryKey = 'upmGlobalSearch'

type UseUpmGlobalSearchOptions<TData = GlobalSearchResponse> = Omit<
  UseQueryOptions<GlobalSearchResponse, AxiosError, TData>,
  'queryKey' | 'queryFn'
>

export const useUpmGlobalSearch = <TData = GlobalSearchResponse>(
  params: GlobalSearchParameters,
  options?: UseUpmGlobalSearchOptions<TData>
) => {
  return useQuery<GlobalSearchResponse, AxiosError, TData>({
    queryKey: [UpmGlobalSearchQueryKey, params],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.post<GlobalSearchResultItem[]>(
        '/upm/search/global',
        params,
        {signal}
      )

      const paginationRaw = response.headers['pagination']
      const pagination: PaginationHeader = paginationRaw
        ? JSON.parse(paginationRaw)
        : {
            currentPage: params.pageNumber,
            pageSize: params.pageSize,
            totalItems: response.data.length,
            totalPages: 1,
            hasNext: false,
            hasPrevious: false
          }

      return {items: response.data, pagination}
    },
    ...options
  })
}
